module.exports = __webpack_public_path__ + "img/HY3701-193.a256f4bf.jpg";